import {
  MspTenant,
  SystemNotificationPreference,
} from '@hakimo-ui/hakimo/types';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { ReactNode } from 'react';

export const pageTitleAtom = atom<{
  pageTitleNode: React.ReactNode;
  pageActions?: ReactNode[];
}>({
  pageTitleNode: null,
  pageActions: [],
});
export const draggableNodeAtom = atom<ReactNode>(null);
export const audioNotifyAtom = atomWithStorage<boolean>(
  'alarmAudioNotification',
  false
);
export const escalationAudioNotifyAtom = atomWithStorage<boolean>(
  'escalationAudioNotification',
  false
);
export const systemNotifyAtom = atomWithStorage(
  'systemNotification',
  SystemNotificationPreference.OFF
);

// `MspTenant`, not `Selectable`: the tenant objects the backend sends carry a
// `version`, and the raw-alarm surfaces read it to pick their dataset. Only the
// extra field is optional, so plain Selectables still assign cleanly.
export const currentTenantAtom = atom<MspTenant | undefined>(undefined);

export const showRootHeaderAtom = atom<boolean>(false);
